<script>
import FormMixin from './../../mixins/form-mixin'
import { logoutResource } from '@services/auth'
export default {

  mixins: [ FormMixin ],

  name: 'LogOut',
  data() {
    return {
      formdata: {}
    }
  },

  methods: {
    send(data) {
      return logoutResource.execute({}, data)
        .then((res) => {
          window.location.replace(window.location.origin)
        })
    },
  },
  

  render(h) {
    return this.$scopedSlots.default({
      logOut: () => {
        this.submit(true)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/LogOut/LogOut.vue